<template>
	<div id="gc-nav-container">
		<div id="gc-nav">
			<ul>
				<li :class="{ active : step == 1 }">
					<router-link to="../gift-card/purchase">
						<span class="num">1</span>
						<span class="text">{{ wpNavOptions.step_1_title }}</span>
					</router-link>
				</li>
				<li :class="{ active : step == 2 }">
					<router-link to="../gift-card/send" :class="{ 'disabled-router-link': step < 2 }">
						<span class="num">2</span>
						<span class="text">{{ wpNavOptions.step_2_title }}</span>
					</router-link>
				</li>
				<li :class="{ active : step == 3 }">
					<span class="num">3</span>
					<span class="text">{{ wpNavOptions.step_3_title }}</span>
				</li>
			</ul>
			<router-link
				tag="button"
				id="gc-nav-next-step"
				:disabled="buttonDisabled"
				:to="nextButtonLink"
			>
				{{ wpNavOptions['step_' + step + '_button'] }}
			</router-link>

		</div>
	</div>
</template>

<script>
export default {

  name: 'GiftCardNav',

  data () {
    return {
    	wpNavOptions: wpData.globalOptions.gc_purchase_nav,
    }
  },
  props: {
  	step: { type: Number, default: 1 },
  	buttonDisabled: { type: Boolean, default: true }
  },
  computed: {
  	nextButtonLink() {
  		switch ( this.step ) {
  			case 1:
				return './send';
			case 2:
        // this.$router.push({
        //   name: "orderEnter",
        //   params: { redirectTo: '/gift-card/pay' },
        // });
				return './pay';
				//return '/order-enter';
  		}
  	}
  },
  mounted(){
  	const container = document.querySelector('#gc-nav-container');
  	const nav = document.querySelector('#gc-nav');
  	window.addEventListener( 'scroll', e => {
  		const containerPos = container.getBoundingClientRect();
  		if ( containerPos.top >= 0 && containerPos.bottom <= window.innerHeight ) {
  			nav.classList.add('sticky');
  		} else {
  			nav.classList.remove('sticky');
  		}

  	});
  }

}
</script>

<style lang="sass" scoped>

	@import '../../assets/sass/gift-card-abstracts.sass'

	.disabled-router-link
		pointer-events: none

	#gc-nav-container
		position: relative
		height: 6rem
		background-color: transparent
		margin-top: 2rem
		+tablet
			height: 3rem

	#gc-nav
		position: fixed
		z-index: 3
		bottom: 0
		left: 0
		width: 100%
		height: 6rem
		background-color: $white
		box-shadow: 0 0 4rem 0 rgba($black, 0.5)
		&.sticky
			position: relative

		ul
			display: flex
			height: 100%
			padding: 0 4rem
			align-items: center
			li
				margin-left: 3rem
				.num
					display: inline-block
					width: 2rem
					height: 2rem
					font-size: 1.25rem
					margin-left: 0.5rem
					padding: 0
					background-color: darken($white, 10%)
					color: darken($white, 40%)
					border-radius: 100%
					text-align: center
					line-height: 1.65
				.text
					font-size: 1.25rem
					color: lighten($black, 50%)
				&:before
					display: none
				&.active
					.num
						color: $white
						background-color: $main
					.text
						font-weight: bold
						color: $main

		#gc-nav-next-step
			position: absolute
			top: 50%
			left: 7rem
			transform: translateY(-50%)
			border: none
			outline: none
			font-size: 1.25rem
			background-color: $main
			color: $white
			padding: 1rem 2rem 1rem 4rem
			border-radius: 6rem
			opacity: 1
			&:hover, &:focus
				background-color: lighten($main, 4%)
			&:active
				background-color: lighten($main, 7%)
			&:before
				content: ''
				width: 0.5rem
				height: 0.5rem
				border-top: 2px solid $white
				border-left: 2px solid $white
				position: absolute
				top: 50%
				left: 1.5rem
				transform: translateY(-50%) rotate(-45deg)

		#gc-nav-next-step[disabled]
			cursor: not-allowed
			opacity: 0.3

	// Tablet
	// @media screen and (max-width: 1350px)

	// Mobile
	+tablet
		#gc-nav
			height: 3rem
			ul
				padding-right: 0rem
				padding-left: 0
				width: 15rem
				transform: translateY(2px)
				li
					white-space: nowrap
					margin-left: -0.5rem
					.text
						display: none
					.num
						width: 1.75rem
						height: 1.75rem
						font-size: 1rem
						line-height: 1.75
						margin-left: 0.35rem

				li.active
					margin-left: 0.5rem
					.text
						display: inline-block
						font-size: 1rem

			#gc-nav-next-step
				font-size: 1rem
				left: 10px
				width: calc(100% - 17rem)
				max-width: 18rem
				white-space: nowrap
				overflow: hidden
				text-overflow: ellipsis
				padding: 0.5rem 0.75rem 0.5rem 2rem
				&:before
					left: 1rem

</style>